module.exports = __webpack_public_path__ + "static/media/Group14.68371c9f.png";